import Vue from 'vue';
import Router from 'vue-router';
import Main from 'view/Main';
import Login from 'view/Login';
// 合并所有router
let routers = [];
const requireComponent = require.context('./modules', false, /\.js$/); // modules下任意js文件
requireComponent.keys().forEach(fileName => {
    const item = requireComponent(fileName);
    routers = routers.concat(item.default); // modules中文件的写法是export default
});
Vue.use(Router);
const router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'main',
            component: Main,
            redirect: '/index',
            linkActiveClass: 'active',
            children: routers
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '*',
            component: Error
        }
    ]
});
export default router;
